import { r as registerInstance, c as createEvent, h } from './index-4df07f2a.js';
import { g as identity_1, h as _baseEach, i as isArrayLike_1, j as _isIndex, f as _baseIteratee, l as _arraySome, m as map_1 } from './map-8afd9017.js';
import { i as isArray_1, n as isObject_1, e as eq_1, r as get_1 } from './get-f8984301.js';
import { i as isEmpty_1 } from './isEmpty-e6d17a41.js';

const scmpMenuEditionListCss = ".scmp-menu-edition-list{position:absolute;border:1px solid #d7d7d7;background:#fff;padding:.5714285714285714rem 0;border-radius:.2857142857142857rem;top:-.42857142857142855rem;right:0}.scmp-menu-edition-list__item{font-size:1.142857142857143rem;line-height:120%;padding:.42857142857142855rem 1.142857142857143rem;color:#6f6f6f;font-family:'Roboto',sans-serif;white-space:nowrap;cursor:pointer;transition:color .2s}.scmp-menu-edition-list__item--active,.scmp-menu-edition-list__item:hover{color:#000}";

let ScmpMenuEditionList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.editionClicked = createEvent(this, "editionClicked", 7);
    this.editionClickedHandler = (edition) => {
      this.editionClicked.emit({ edition });
    };
  }
  handleClickOutside(event) {
    if (!this.editionElement.contains(event.target)) {
      this.close();
    }
  }
  activeClass(id) {
    if (this.edition === id) {
      return 'scmp-menu-edition-list__item--active';
    }
    return '';
  }
  render() {
    return (h("div", { class: "scmp-menu-edition-list", ref: (el) => (this.editionElement = el) }, this.editionList && this.editionList.map((edition) => {
      return (h("div", { key: edition.id, class: `scmp-menu-edition-list__item ${this.activeClass(edition.id)}`, onClick: () => this.editionClickedHandler(edition) }, edition.name));
    })));
  }
};
ScmpMenuEditionList.style = scmpMenuEditionListCss;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity_1;
}

var _castFunction = castFunction;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray_1(collection) ? _arrayEach : _baseEach;
  return func(collection, _castFunction(iteratee));
}

var forEach_1 = forEach;

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  _baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

var _baseSome = baseSome;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray_1(collection) ? _arraySome : _baseSome;
  if (guard && _isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, _baseIteratee(predicate));
}

var some_1 = some;

const scmpMenuListCss = ".scmp-menu-list{font-family:'Roboto',sans-serif;background:#222834}.scmp-menu-list__menu-wrapper{margin-bottom:24px}.scmp-menu-list__menu-wrapper--accordion-list{display:flex;flex-wrap:wrap}.scmp-menu-list__menu-wrapper--accordion-list .scmp-menu-list__menu-item{border:1px solid rgba(161,161,161,0.3);border-width:0 0 1px;flex:1 1 50%;position:relative;box-sizing:border-box}.scmp-menu-list__menu-wrapper--accordion-list .scmp-menu-list__menu-item:nth-child(odd){padding-left:12px}.scmp-menu-list__menu-wrapper--accordion-list .scmp-menu-list__menu-item:nth-child(odd):before{content:'';position:absolute;top:12px;bottom:12px;left:0;border-left:1px solid rgba(161,161,161,0.3)}.scmp-menu-list__menu-wrapper--accordion-list .scmp-menu-list__menu-item:nth-child(even){padding-right:12px}.scmp-menu-list__menu-item{border:1px solid rgba(161,161,161,0.3);border-width:0 0 1px}.scmp-menu-list__menu-header{font-size:12px;line-height:16.8px;color:#ffca05;font-weight:700;text-transform:uppercase;width:100%;margin-bottom:4px}.scmp-menu-list__button-list{margin-bottom:24px;display:flex;justify-content:space-between}.scmp-menu-list__topic-list{color:#ffca05;font-weight:700;font-size:14px;line-height:19.6px;text-transform:uppercase;display:flex;flex-wrap:wrap;margin-left:-3px;margin-right:-3px}.scmp-menu-list__topic-card{flex:1 0 50%;padding:0 3px;box-sizing:border-box;max-width:50%;margin-bottom:7px}";

let ScmpMenuList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isLeftPadded = false;
  }
  menuList(items, { inputTier = 0, theme = 'section-list', headerName = '' }) {
    let tier = 0;
    if (theme === 'section-list') {
      forEach_1(items, (sublist) => {
        const sublistChildren = get_1(sublist, 'children', []);
        if (!this.isLeftPadded) {
          this.isLeftPadded = some_1(sublistChildren, (sublistChild) => {
            return !isEmpty_1(sublistChild.children);
          });
        }
      });
    }
    return (map_1(items, (item) => {
      const { text, children = [] } = item;
      if (isEmpty_1(children) && inputTier === 0)
        return null;
      if (!isEmpty_1(children) && inputTier < 1) {
        const className = `scmp-menu-list__menu-wrapper ${theme === 'accordion-list' ? 'scmp-menu-list__menu-wrapper--accordion-list' : ''}`;
        return (h("div", { class: className }, h("div", { class: "scmp-menu-list__menu-header" }, text), this.menuList(children, {
          inputTier: tier + 1,
          theme,
          headerName: text
        })));
      }
      return (h("div", { class: "scmp-menu-list__menu-item" }, h("scmp-menu-list-item", { parent: this.parent, selectedTabText: this.selectedTabText, menuItem: item, theme: theme, isLeftPadded: this.isLeftPadded, queryString: this.queryString, headerName: headerName })));
    }));
  }
  topicCardList(items) {
    return (map_1(items, (item) => {
      return (h("div", { class: "scmp-menu-list__topic-card" }, h("scmp-menu-topic-card", { topicCardItem: item, queryString: this.queryString })));
    }));
  }
  get content() {
    const items = this.menuItems;
    return (h("div", { class: "scmp-menu-list__menu-list" }, this.menuList(items, {
      inputTier: 0,
      theme: this.theme,
    })));
  }
  render() {
    return (h("div", { class: "scmp-menu-list" }, this.content));
  }
};
ScmpMenuList.style = scmpMenuListCss;

const MynewsLogo = `<svg width="75" height="24" viewBox="0 0 75 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.666626" y="0.5" width="73.8333" height="23" rx="1.5" fill="white"/>
<path d="M12.9096 8.86536L12.7446 9.60175C13.3471 8.99903 14.044 8.70739 14.8352 8.72683C15.2491 8.73655 15.6107 8.8362 15.9198 9.02576C16.2342 9.21533 16.4569 9.49482 16.5879 9.86423C17.2638 9.09138 18.0367 8.70982 18.9065 8.71954C19.4776 8.73412 19.9282 8.90182 20.2583 9.22262C20.5884 9.54342 20.7796 9.9906 20.832 10.5642C20.8635 10.8995 20.8609 11.2374 20.8242 11.5776L19.8889 16.7615H18.5449L19.4723 11.563L19.4959 10.9506C19.4854 10.6055 19.3859 10.3381 19.1973 10.1486C19.0139 9.95415 18.7493 9.85694 18.4034 9.85694C17.9895 9.84721 17.6175 10.0028 17.2874 10.3236C16.9573 10.6444 16.7556 11.0259 16.6822 11.4682V11.5047L15.7155 16.7615H14.3479L15.2832 11.5703C15.3042 11.3759 15.3094 11.1766 15.2989 10.9725C15.2622 10.2579 14.9059 9.88853 14.23 9.86423C13.5855 9.85451 13.0485 10.1802 12.6188 10.8412L11.5185 16.7615H10.1666L11.6442 8.87265L12.9096 8.86536Z" fill="#222834"/>
<path d="M23.6636 14.5961L26.2415 8.87265H27.727L23.3256 17.9864C23.0269 18.6474 22.6706 19.1457 22.2567 19.481C21.848 19.8213 21.4026 19.9841 20.9206 19.9695C20.7582 19.9647 20.5014 19.9209 20.1503 19.8383L20.284 18.7447L20.5748 18.7884C21.2612 18.8176 21.7956 18.4919 22.1781 17.8114L22.7519 16.6157L21.793 8.87265H23.2234L23.6636 14.5961Z" fill="#222834"/>
<path d="M36.5099 16.7615H34.1992L30.8195 9.79861V16.7615H28.5088V6.14582H30.8195L34.207 13.116V6.14582H36.5099V16.7615Z" fill="#222834"/>
<path d="M44.2751 12.1682H40.6754V14.9825H44.9353V16.7615H38.3647V6.14582H44.9196V7.93211H40.6754V10.4402H44.2751V12.1682Z" fill="#222834"/>
<path d="M53.7066 12.8171L54.7912 6.14582H57.0783L55.0427 16.7615H52.7241L51.388 10.5058L50.0676 16.7615H47.7412L45.6977 6.14582H48.0005L49.0773 12.8098L50.4213 6.14582H52.3626L53.7066 12.8171Z" fill="#222834"/>
<path d="M62.6586 13.9763C62.6586 13.5437 62.5381 13.2181 62.2971 12.9994C62.0613 12.7758 61.629 12.5449 61.0002 12.3067C59.8527 11.9033 59.0275 11.4318 58.5245 10.8923C58.0215 10.3479 57.77 9.70626 57.77 8.96743C57.77 8.07307 58.1105 7.35612 58.7917 6.81659C59.4781 6.2722 60.3479 6 61.4011 6C62.1032 6 62.7293 6.13853 63.2795 6.41559C63.8297 6.68778 64.2515 7.07421 64.5449 7.57485C64.8436 8.0755 64.9929 8.6442 64.9929 9.28095H62.6901C62.6901 8.78516 62.5748 8.40846 62.3442 8.15084C62.1189 7.88837 61.7914 7.75713 61.3618 7.75713C60.9583 7.75713 60.6439 7.86893 60.4186 8.09252C60.1933 8.31125 60.0807 8.60775 60.0807 8.98202C60.0807 9.27366 60.2064 9.53856 60.4579 9.77674C60.7094 10.01 61.1548 10.2531 61.7941 10.5058C62.9101 10.8801 63.7197 11.3394 64.2227 11.8838C64.7309 12.4282 64.985 13.1209 64.985 13.9618C64.985 14.8853 64.668 15.6071 64.034 16.1272C63.4 16.6473 62.5381 16.9073 61.4482 16.9073C60.7094 16.9073 60.0361 16.7664 59.4283 16.4845C58.8205 16.2025 58.3437 15.7991 57.9979 15.2741C57.6573 14.7492 57.487 14.1295 57.487 13.4149H59.8056C59.8056 14.0274 59.934 14.4721 60.1907 14.7492C60.4475 15.0263 60.8666 15.1648 61.4482 15.1648C62.2552 15.1648 62.6586 14.7686 62.6586 13.9763Z" fill="#222834"/>
<rect x="0.666626" y="0.5" width="73.8333" height="23" rx="1.5" stroke="white"/>
</svg>
`;

const IconClose = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.0157 10.0393L20 18.9843L19.0629 20L10 10.9764L1.01571 20L0 18.9843L8.98429 10.0393L0 1.01571L1.01571 0L10 9.02357L19.0629 0L20 1.01571L11.0157 10.0393Z" fill="white"/>
</svg>
`;

const IconBookmark = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.9574 3.33993C15.9574 2.77129 15.7618 2.27661 15.3712 1.85521C14.9806 1.43518 14.5163 1.22482 13.979 1.22482H3.3543C2.817 1.22482 2.35205 1.43518 1.96147 1.85521C1.57089 2.27661 1.37526 2.77129 1.37526 3.33993V16.9962L8.74003 12.2089L15.9574 16.9589V3.33993ZM16.2502 0.964929C16.8612 1.60821 17.1667 2.38789 17.1667 3.30261V19L8.74003 13.5076L0.166672 19V3.30261C0.166672 2.38789 0.472169 1.60821 1.08249 0.964929C1.69282 0.322321 2.42575 0 3.2806 0H14.0521C14.9076 0 15.6399 0.322321 16.2502 0.964929Z" fill="white"/>
</svg>
`;

const IconArrowDown = `<svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.41 0.295013L6 4.87501L10.59 0.295013L12 1.70501L6 7.70501L0 1.70501L1.41 0.295013Z" fill="white"/>
</svg>
`;

const scmpMenuMobileHeaderCss = ".scmp-menu-mobile-header{display:flex;box-sizing:border-box;width:100%;justify-content:space-between;align-items:center;background-color:#222834}.scmp-menu-mobile-header__logo{width:2.285714285714286rem;height:1.785714285714286rem;display:block}.scmp-menu-mobile-header__close{width:1.428571428571429rem;height:1.428571428571429rem}.scmp-menu-mobile-header__edition-container{flex:1}.scmp-menu-mobile-header__edition-wrapper{position:relative;display:flex;align-items:center;width:fit-content}.scmp-menu-mobile-header__edition-text{display:block;font-family:'Roboto',sans-serif;color:#fff;opacity:.7;font-size:1rem;line-height:1.142857142857143rem;margin-right:.2857142857142857rem}.scmp-menu-mobile-header__selector{display:flex;align-items:center;justify-content:flex-start;position:relative;cursor:pointer;min-width:7.142857142857143rem}.scmp-menu-mobile-header__selector--open .scmp-menu-mobile-header__arrow{transform:rotate(180deg)}.scmp-menu-mobile-header__arrow{transition:transform .2s}.scmp-menu-mobile-header__edition{font-family:'Roboto',sans-serif;color:#fff;font-size:1rem;line-height:1.142857142857143rem;display:block;font-weight:700;cursor:pointer;margin-right:.5714285714285714rem;user-select:none}.scmp-menu-mobile-header__bookmark{display:none;margin-right:1.142857142857143rem;position:relative}@media (min-width:321px){.scmp-menu-mobile-header__bookmark{display:inline-flex}}.scmp-menu-mobile-header__bookmark--new:after{content:\"\";position:absolute;top:-.14285714285714285rem;right:-.10714285714285714rem;width:.2857142857142857rem;height:.2857142857142857rem;border-radius:50%;background:#eb4254;z-index:1}.scmp-menu-mobile-header__mynews{display:inline-flex;margin-right:1.142857142857143rem}";

let ScmpMenuMobileHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.closeClicked = createEvent(this, "closeClicked", 7);
    this.bookmarkClicked = createEvent(this, "bookmarkClicked", 7);
    this.myNewsClicked = createEvent(this, "myNewsClicked", 7);
    this.linkHref = 'https://scmp.com';
    this.isEditionOpen = false;
    this.closeClickHandler = () => {
      this.closeClicked.emit();
    };
    this.editionClickHandler = () => {
      this.isEditionOpen = !this.isEditionOpen;
    };
    this.closeEditionClickHandler = () => {
      this.isEditionOpen = false;
    };
    this.bookmarkEditionClickHandler = () => {
      this.bookmarkClicked.emit();
    };
    this.myNewsClickedHandler = () => {
      this.myNewsClicked.emit();
    };
  }
  get isEditionOpenClass() {
    return this.isEditionOpen ? 'scmp-menu-mobile-header__selector--open' : '';
  }
  get isShowBookmarkAlertClass() {
    return this.isShowBookmarkAlert ? 'scmp-menu-mobile-header__bookmark--new' : '';
  }
  get currentEdition() {
    const current = this.editionList.find(edition => edition.id === this.edition);
    return current ? current.name : '';
  }
  render() {
    return (h("div", { class: "scmp-menu-mobile-header" }, h("div", { class: "scmp-menu-mobile-header__edition-container" }, h("div", { class: "scmp-menu-mobile-header__edition-wrapper" }, h("span", { class: "scmp-menu-mobile-header__edition-text" }, "Edition:"), h("div", { class: `scmp-menu-mobile-header__selector ${this.isEditionOpenClass}`, onClick: this.editionClickHandler }, h("span", { class: "scmp-menu-mobile-header__edition" }, this.currentEdition), h("div", { class: "scmp-menu-mobile-header__arrow", innerHTML: IconArrowDown })), this.isEditionOpen && (h("scmp-menu-edition-list", { editionList: this.editionList, edition: this.edition, close: this.closeEditionClickHandler })))), h("div", { class: `scmp-menu-mobile-header__bookmark ${this.isShowBookmarkAlertClass}`, innerHTML: IconBookmark, onClick: this.bookmarkEditionClickHandler }), h("a", { class: "scmp-menu-mobile-header__mynews", innerHTML: MynewsLogo, href: "/mynews", target: "_blank", onClick: this.myNewsClickedHandler }), h("div", { class: "scmp-menu-mobile-header__close", innerHTML: IconClose, onClick: this.closeClickHandler })));
  }
};
ScmpMenuMobileHeader.style = scmpMenuMobileHeaderCss;

const scmpMenuNonSubscriberInstructionCss = ".scmp-menu-non-subscriber-instruction{display:flex;flex-direction:column}.scmp-menu-non-subscriber-instruction__button{margin-bottom:6px}.scmp-menu-non-subscriber-instruction__instruction-text{color:rgba(255,255,255,0.6);font-family:'Roboto Condensed',sans-serif;font-size:15px;font-weight:400;line-height:18px}";

const defaultInstruction = 'Get unlimited access to the SCMP';
let ScmpMenuNonSubscriberInstruction = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.instruction = defaultInstruction;
  }
  render() {
    return (h("div", { class: "scmp-menu-non-subscriber-instruction" }, h("div", { class: "scmp-menu-non-subscriber-instruction__button" }, h("scmp-menu-subscribe-button", { linkHref: this.linkHref, text: this.buttonText })), h("div", { class: "scmp-menu-non-subscriber-instruction__instruction-text" }, this.instruction)));
  }
};
ScmpMenuNonSubscriberInstruction.style = scmpMenuNonSubscriberInstructionCss;

const IconSearch = `<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.92607 16.435C11.0039 16.435 12.7751 15.7027 14.2389 14.2389C15.7035 12.7751 16.435 11.0039 16.435 8.92607C16.435 6.84741 15.7035 5.06927 14.2389 3.58908C12.7751 2.10975 11.0039 1.36965 8.92607 1.36965C6.84827 1.36965 5.06841 2.10975 3.58908 3.58908C2.10889 5.06927 1.36965 6.84741 1.36965 8.92607C1.36965 11.0039 2.10889 12.7751 3.58908 14.2389C5.06841 15.7027 6.84827 16.435 8.92607 16.435V16.435ZM22.1027 23L14.7354 15.6318C13.0972 17.081 11.161 17.8046 8.92607 17.8046C6.47002 17.8046 4.3689 16.9393 2.621 15.207C0.873954 13.4755 0 11.3813 0 8.92607C0 6.47002 0.873954 4.36804 2.621 2.621C4.3689 0.87309 6.47002 0 8.92607 0C11.3821 0 13.4755 0.87309 15.207 2.621C16.9385 4.36804 17.8046 6.47002 17.8046 8.92607C17.8046 11.1619 17.0801 13.0981 15.6327 14.7346L23 22.1019L22.1027 23Z" fill="#222834"/>
</svg>
`;

const IconSearchCancel = `<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.1457 9.5L12.8571 12.2115L11.7113 13.3571L8.99985 10.6459L6.28874 13.3571L5.14286 12.2115L7.85397 9.5L5.14286 6.78849L6.28874 5.64286L8.99985 8.35407L11.7113 5.64286L12.8571 6.78849L10.1457 9.5ZM15.363 15.863C13.6054 17.6206 11.484 18.5 9 18.5C6.51536 18.5 4.39457 17.6206 2.63636 15.863C0.878786 14.1054 0 11.9846 0 9.5C0 7.01536 0.878786 4.89393 2.63636 3.13636C4.39457 1.37879 6.51536 0.5 9 0.5C11.484 0.5 13.6054 1.37879 15.363 3.13636C17.1212 4.89393 18 7.01536 18 9.5C18 11.9846 17.1212 14.1054 15.363 15.863Z" fill="currentColor"/>
</svg>
`;

const scmpMenuSearchAreaCss = ".scmp-menu-search-area{float:right;background-color:#a7a9ae;height:2.928571428571428rem;width:2.928571428571428rem;border-radius:2.928571428571428rem;display:flex;align-items:center;justify-content:flex-start;overflow:hidden;transition:all;transition-duration:.3s;transition-timing-function:ease-in-out;padding:0 .6428571428571429rem;box-sizing:border-box;cursor:pointer}.scmp-menu-search-area__search{width:1.642857142857143rem;height:1.642857142857143rem}.scmp-menu-search-area__input{display:none;flex:0;padding-left:.5714285714285714rem;position:relative}.scmp-menu-search-area__input-field{width:100%;background-color:transparent;font-size:1.142857142857143rem;line-height:1.357142857142857rem;font-family:'Roboto',sans-serif;border:0;color:#222834;box-sizing:border-box}.scmp-menu-search-area__input-field::placeholder{color:rgba(34,40,52,0.5)}.scmp-menu-search-area__input-field:focus{outline:none}.scmp-menu-search-area__input-cancel{top:.14285714285714285rem;right:.8214285714285714rem;width:1.285714285714286rem;height:1.357142857142857rem;user-select:none;display:none;color:#777}.scmp-menu-search-area--expand{width:100%}.scmp-menu-search-area--expand .scmp-menu-search-area__search{pointer-events:none}.scmp-menu-search-area--expand .scmp-menu-search-area__input{display:block;flex:1}.scmp-menu-search-area--expand .scmp-menu-search-area__input-cancel{display:block}";

let ScmpMenuSearchArea = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.searchOpenClicked = createEvent(this, "searchOpenClicked", 7);
    this.searchCloseClicked = createEvent(this, "searchCloseClicked", 7);
    this.searchTextChanged = createEvent(this, "searchTextChanged", 7);
    this.searchTextSubmitted = createEvent(this, "searchTextSubmitted", 7);
    this.defaultExpand = false;
    this.isTyping = false;
    this.handleOnClick = () => {
      if (!this.isSearchOpen) {
        this.searchOpenClicked.emit();
      }
      this.isSearchOpen = !this.isSearchOpen;
    };
    this.handleInput = (e) => {
      const { keyCode } = e;
      const inputVal = get_1(this.textInput, 'value');
      this.isTyping = !!inputVal;
      if (keyCode === 13) {
        this.searchTextSubmitted.emit({ searchText: inputVal });
      }
      else {
        this.searchTextChanged.emit({ searchText: inputVal });
      }
    };
    this.clearInput = () => {
      this.textInput.value = '';
      this.isTyping = false;
    };
    this.closeClickedHandler = () => {
      this.searchCloseClicked.emit();
      this.clearInput();
    };
  }
  get isOpen() {
    return this.defaultExpand || this.isSearchOpen;
  }
  render() {
    return (h("div", { class: {
        'scmp-menu-search-area': true,
        'scmp-menu-search-area--expand': this.isOpen,
      } }, h("div", { class: "scmp-menu-search-area__search", innerHTML: IconSearch, onClick: this.handleOnClick }), h("div", { class: "scmp-menu-search-area__input" }, h("input", { class: "scmp-menu-search-area__input-field", type: "text", placeholder: "Search", onKeyUp: this.handleInput, ref: (el) => this.textInput = el })), !this.defaultExpand && this.isTyping && (h("div", { class: "scmp-menu-search-area__input-cancel", innerHTML: IconSearchCancel, onClick: this.closeClickedHandler }))));
  }
};
ScmpMenuSearchArea.style = scmpMenuSearchAreaCss;

const IconCaretForward = `<svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.583956 9.28572C0.413441 9.28572 0.273625 9.23261 0.164175 9.1264C0.0547247 9.0435 0 8.90781 0 8.71902L0 1.281C0 1.15114 0.0547247 1.01546 0.164175 0.873618C0.273625 0.767402 0.413441 0.714294 0.583956 0.714294C0.717765 0.714294 0.839562 0.767402 0.949012 0.873618L4.7811 4.59279C4.92726 4.73431 5 4.86999 5 5.00017C5 5.1297 4.92726 5.26571 4.7811 5.40722L0.949012 9.1264C0.839562 9.23261 0.717765 9.28572 0.583956 9.28572Z" fill="rgba(255, 255, 255, 0.4)"/>
</svg>
`;

const scmpMenuSubscribeButtonCss = ".scmp-menu-subscribe-button{border:1px solid rgba(255,255,255,0.6);border-radius:3px;width:fit-content}.scmp-menu-subscribe-button__text{margin-right:6px}.scmp-menu-subscribe-button__anchor{color:rgba(255,255,255,0.6);font-family:'Roboto Condensed',sans-serif;font-size:15px;font-weight:400;line-height:18px;text-decoration:none}.scmp-menu-subscribe-button__text-and-icon{display:flex;align-items:center;padding:3px 7px}";

const defaultLinkRef = 'https://subscribe.scmp.com/';
const defaultText = 'SUBSCRIBE';
let ScmpMenuSubscribeButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.subscribeClicked = createEvent(this, "subscribeClicked", 7);
    this.linkHref = defaultLinkRef;
    this.text = defaultText;
  }
  render() {
    const handleSubscribeClick = () => {
      this.subscribeClicked.emit();
    };
    return (h("div", { class: "scmp-menu-subscribe-button" }, h("a", { class: "scmp-menu-subscribe-button__anchor", href: this.linkHref, onClick: handleSubscribeClick }, h("div", { class: "scmp-menu-subscribe-button__text-and-icon" }, h("div", { class: "scmp-menu-subscribe-button__text" }, this.text), h("span", { class: "scmp-menu-subscribe-button__caret-forward", innerHTML: IconCaretForward })))));
  }
};
ScmpMenuSubscribeButton.style = scmpMenuSubscribeButtonCss;

const scmpMenuSwitchVersionButtonCss = ".scmp-menu-switch-version-button{display:block;width:100%;padding:8px 0;text-align:center;background:#ffca05;color:#001246;font-family:'Roboto',sans-serif;font-size:12px;font-weight:700;text-decoration:none;margin-bottom:12px;margin-top:-12px;cursor:pointer}";

let ScmpMenuSwitchVersionButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.backToHomepageClicked = createEvent(this, "backToHomepageClicked", 7);
    this.showBackToV1Button = false;
    this.showBackToV2Button = false;
    this.clickHandler = () => {
      this.backToHomepageClicked.emit();
    };
  }
  get text() {
    return this.showBackToV1Button ? '< Back to original SCMP.com' : 'See the new SCMP.com >';
  }
  render() {
    if (!this.showBackToV1Button && !this.showBackToV2Button) {
      return null;
    }
    return (h("div", { class: "scmp-menu-switch-version-button", onClick: this.clickHandler }, this.text));
  }
};
ScmpMenuSwitchVersionButton.style = scmpMenuSwitchVersionButtonCss;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce;

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

var _baseReduce = baseReduce;

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray_1(collection) ? _arrayReduce : _baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, _baseIteratee(iteratee), accumulator, initAccum, _baseEach);
}

var reduce_1 = reduce;

const scmpMenuTabSectionCss = ".scmp-menu-tab-section{font-family:'Roboto',sans-serif;background:#222834}.scmp-menu-tab-section__menu-wrapper{margin-bottom:24px}.scmp-menu-tab-section__menu-item{border:1px solid rgba(161,161,161,0.3);border-width:0 0 1px}.scmp-menu-tab-section__menu-header{font-size:13px;line-height:18.2px;color:#ffca05;font-weight:700;text-transform:uppercase}.scmp-menu-tab-section__button{flex:1;padding-left:3px;padding-right:3px}.scmp-menu-tab-section__button-list{margin-left:-3px;margin-right:-3px;margin-bottom:12px;display:flex;justify-content:space-between}.scmp-menu-tab-section__topic-list{color:#ffca05;font-weight:700;font-size:14px;line-height:19.6px;display:flex;flex-wrap:wrap;margin-left:-3px;margin-right:-3px;padding-top:16px}.scmp-menu-tab-section__topic-card{flex:1 0 50%;padding:0 3px;box-sizing:border-box;max-width:50%;margin-bottom:7px}";

let ScmpMenuTabSection = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buttonClicked = createEvent(this, "buttonClicked", 7);
    this.buttonClickHandler = (tab) => {
      this.buttonClicked.emit({
        ref: this.buttonContainer,
        tab
      });
    };
  }
  get content() {
    return map_1(this.tabs, (tab, index) => {
      const items = get_1(tab, 'items', []);
      const selectedTabText = get_1(tab, 'button.text', '');
      const selectedType = get_1(tab, 'type');
      const menuItems = reduce_1(items, (arr, item) => {
        if (!item.children) {
          arr[0].children.push(item);
        }
        else {
          arr.push(item);
        }
        return arr;
      }, [{
          text: selectedTabText,
          children: []
        }]);
      return (h("div", { class: "scmp-menu-tab-section__menu-list" }, h("scmp-menu-list", { key: index, menuItems: menuItems, selectedTabText: selectedTabText, theme: selectedType, queryString: this.queryString })));
    });
  }
  render() {
    return (h("div", { class: "scmp-menu-tab-section" }, this.content));
  }
};
ScmpMenuTabSection.style = scmpMenuTabSectionCss;

export { ScmpMenuEditionList as scmp_menu_edition_list, ScmpMenuList as scmp_menu_list, ScmpMenuMobileHeader as scmp_menu_mobile_header, ScmpMenuNonSubscriberInstruction as scmp_menu_non_subscriber_instruction, ScmpMenuSearchArea as scmp_menu_search_area, ScmpMenuSubscribeButton as scmp_menu_subscribe_button, ScmpMenuSwitchVersionButton as scmp_menu_switch_version_button, ScmpMenuTabSection as scmp_menu_tab_section };
